const config = {
  API_URL: import.meta.env.VITE_API_URL || '',
  JOBSEEKER_API_URL: import.meta.env.VITE_JOBSEEKER_API_URL || '',
  CRYPTO_SECRET_KEY: import.meta.env.VITE_CRYPTO_SECRET_KEY || '',
  JWT_SECRET: import.meta.env.VITE_JWT_SECRET || '',
  AWS_CDN_LINK: import.meta.env.VITE_AWS_CDN_LINK || '',
  CANDIDATE_MANAGER_URL: import.meta.env.VITE_CANDIDATE_MANAGER_URL || ''
};

export default config;